export const enum MatchingOptionsEnum {
  SOME,
  EVERY,
}
